import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import { heroCardInterface } from '../../compose/hero-card-slider/HeroCardSlider.js';
import { makeStyles, Box, Typography } from '@material-ui/core';
import CustomButton from '../button/custom-button/CustomButton.js';
import { retrieveContentfulImage } from '../../common/image.js';
import { BUTTON_TYPES } from '../../common/constant.js';
import PropTypes__default from 'prop-types';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles = makeStyles(function (theme) {
  return {
    actionButton: {
      backgroundColor: theme.palette.background.white,
      color: theme.palette.text.black,
      "&:hover": {
        backgroundColor: theme.palette.text.white
      }
    },
    whiteText: {
      color: theme.palette.text.white
    },
    hintDarkText: {
      color: "rgba(0, 0, 0, 0.64)"
    },
    titleDarkText: {
      color: theme.palette.text.black
    }
  };
});
var HeroCard = function HeroCard(_ref) {
  var bgColor = _ref.bgColor,
    bgImageUrl = _ref.bgImageUrl,
    bgImagePosition = _ref.bgImagePosition,
    bgImageSize = _ref.bgImageSize,
    hint = _ref.hint,
    title = _ref.title,
    textColor = _ref.textColor,
    actionButtonLabel = _ref.actionButtonLabel,
    onButtonClick = _ref.onButtonClick;
  var classes = useStyles();
  return /*#__PURE__*/React__default.createElement(Box, {
    p: 1.5,
    borderRadius: 8,
    height: 180,
    bgcolor: bgColor,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    style: {
      backgroundImage: bgImageUrl ? "url(".concat(retrieveContentfulImage(bgImageUrl), ")") : "",
      backgroundRepeat: bgImageUrl ? "no-repeat" : "",
      backgroundPosition: bgImagePosition,
      backgroundSize: bgImageSize
    }
  }, /*#__PURE__*/React__default.createElement(Box, null, hint && /*#__PURE__*/React__default.createElement(Typography, {
    variant: "overline",
    className: textColor === "light" ? classes.whiteText : classes.hintDarkText
  }, hint), title && /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h4",
    className: textColor === "light" ? classes.whiteText : classes.titleDarkText
  }, title)), actionButtonLabel && /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(CustomButton, {
    variant: BUTTON_TYPES.Primary.variant,
    color: BUTTON_TYPES.Primary.color,
    borderradius: 4,
    size: "medium",
    className: classes.actionButton,
    onClick: onButtonClick
  }, actionButtonLabel)));
};
HeroCard.propTypes = _objectSpread(_objectSpread({}, heroCardInterface), {}, {
  onButtonClick: PropTypes__default.func
});
HeroCard.defaultProps = {
  bgImagePosition: "center",
  bgImageSize: "cover"
};

export { HeroCard as default };
//# sourceMappingURL=HeroCard.js.map
